import React, { useEffect, useRef, useState } from 'react';

import toast, { Toaster } from 'react-hot-toast';
import ReCAPTCHA from 'react-google-recaptcha';
import { InputMask } from '@react-input/mask';
import config from '../coreFIles/config';
import Header from '../directives/header';
import Leftnav from '../directives/leftSidebar';
import Rightnav from '../directives/rightSidebar';
import Footer from '../directives/footer';
import Cookies from 'js-cookie';
import { tellaFriendAction } from '../Action/action';

const getDomainId = () => {
	try {
		const cookieData = Cookies.get('domain_id');
		return cookieData ? JSON.parse(cookieData) : 0;
	} catch (error) {
		console.error('Error parsing domain_id cookie:', error);
		return 0;
	}
};

const getLoginData = () => {
	try {
		const cookieData = Cookies.get('loginSuccessMember');
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error('Error parsing loginSuccessMember cookie:', error);
		return [];
	}
};

const Domainid = getDomainId();
const loginData = getLoginData();

const getDomainDetails = () => {
	if (Domainid && typeof Domainid === 'object') {
		const { domain_id, data } = Domainid;
		const domainIdValue = (typeof domain_id === 'number' || typeof domain_id === 'string') ? domain_id : 0;
		const domainArray = Array.isArray(data) ? data : [];
		const domainTitle = domainArray.length > 0 ? (domainArray[0]?.title || 'Bondi classifieds') : 'Bondi classifieds';
		return { domainIdValue, domainTitle };
	}
	return { domainIdValue: 0, domainTitle: 'Bondi classifieds' };
};

const TellaFriend = () => {
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');
	
	// style end
    const [spinloader, setspinloader] = useState(0);
    const [validationError, setvalidationError] = useState({});
    const recaptchaRef = useRef(null);

    const { domainIdValue, domainTitle } = getDomainDetails();

    const [form, setForm] = useState({
        id:"7",
        domain_id: domainIdValue || "0",
        title: domainTitle,
        name: '',
        email: '',
        fname: '',
        femail:'',
        msg: '',
        captchaValue:""
    });  
    const inputHandler = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleKeyDown = (e) => {
        if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
            e.preventDefault();
            console.log("hello")
        }
    };
    function validate() {
        let nameError = "";
        let emailError = "";
        let msgError = "";
        let fnameError ='';
        let femailError='';
        let captchaValueError = "";  
        if (form.name === '') nameError = "Name is required.";
        if (form.fname === '') fnameError = "Friend Name is required.";
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (form.email === '') {
            emailError = "Email is required.";
        } else if (!emailRegex.test(form.email)) {
            emailError = "Please enter a valid email address.";        } 
        if (form.femail === '') {
                femailError = "Email is required.";
        } else if (!emailRegex.test(form.femail)) {
                femailError = "Please enter a valid email address.";        } 
                
        if (form.msg === '') msgError = "Message is required.";    
        if (form.captchaValue === '') captchaValueError = "Captcha is required.";    
        if (nameError || emailError || msgError || captchaValueError ||femailError|| fnameError) {
            setvalidationError({
                nameError, emailError, msgError, captchaValueError,fnameError,femailError
            });
            return false;
        } else {
           
            setvalidationError({
                nameError, emailError, msgError, captchaValueError,fnameError,femailError
            });
            return true;
        }
    }
    const onCaptchaChange = (value) => {
        if(!value){
            return null
        }else{
        setForm((prev) => ({ ...prev, captchaValue: value }));
        }
    };
 
    const SubmitForm = async (e) => {
        e.preventDefault();
        const isValid = validate();
        if (!isValid) return;
        setspinloader(1);    
        let res = await tellaFriendAction({ ...form });
        if (res.success) {
            toast.success(res.msg);
            setTimeout(() => {
             window.location.reload()
            }, 1200);
           
        } else {
            toast.error(res.msg);
        }
        setspinloader(0);
    };
    return (
        <>
            <Header />
            <Toaster/>
            <div className="add-section mb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <Leftnav />
                        </div>
                        <div className="col-lg-6">
                            <Toaster />
                            <div className="classification-section">
                                <h2 className="page-heading" style={{background:headerMenuColor}}>  Tell A Friend </h2>
                                <form action='' method='post'>
                                    <div className="bondiclassified-fromsection">
                                        <div className="catagoryfrom">
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Name <span className='text-danger'>*</span></label>
                                                        <input type='text' className='form-control' name='name' id='name' onChange={inputHandler} value={form.name} />
                                                        <span className="text-danger">{validationError.nameError}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Email <span className='text-danger'>*</span></label>
                                                        <input type='text' className='form-control' name='email' id='email' onChange={inputHandler} value={form.email} />
                                                        <span className="text-danger">{validationError.emailError}</span>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                    <label htmlFor="name">Friend Name <span className='text-danger'>*</span></label>
                                                        <input type='text' className='form-control' name='fname' id='fname' onChange={inputHandler} value={form.fname} />
                                                        <span className="text-danger">{validationError.fnameError}</span>
                                                       
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Friend Email <span className='text-danger'>*</span></label>
                                                        <input type='text' className='form-control' name='femail' id='fname' onChange={inputHandler} value={form.femail} />
                                                        <span className="text-danger">{validationError.femailError}</span>
                                                    </div>
                                                </div>


                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <label htmlFor="msg">Message <span className='text-danger'>*</span></label>
                                                        <textarea className="form-control" name="msg" rows='5' id='msg' onChange={inputHandler} value={form.msg}></textarea>
                                                        <span className="text-danger">{validationError.msgError}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group">
                                                        <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        sitekey={config.site_key}
                                                        Secret_key={config.secret_key}
                                                        onChange={onCaptchaChange}
                                                        />
                                                        <span className="text-danger">{validationError.captchaValueError}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-3 pdb-20">
                                                    {spinloader === 0 ? (
                                                        <button 
                                                            type="button"
                                                            onClick={SubmitForm}
                                                            className="btn btn-primary login-btn"
                                                            style={{background:headerButtonColor}}
                                                        >
                                                            Send
                                                        </button>
                                                    ) : (
                                                        <button disabled className="btn btn-primary login-btn"     style={{background:headerButtonColor}}>
                                                            Sending.. <i className="fa fa-spinner fa-spin validat"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <Rightnav />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default TellaFriend;
